<template>
  <el-dialog title="确认处理完成" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="30%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="处理日期:" prop="dealDate">
            <el-date-picker v-model="data.dealDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input v-model="data.dealRemark" type="textarea" :maxlength="1000" placeholder="请输入" clearable/>
      </el-form-item>
      
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { confirmDeal } from "@/api/crm/order";
import { mapState } from 'vuex'

export default {
  name: "expressDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      logisticsCompanyList: [], // 物流公司
      rules: {
        dealDate: [
          {required: true, message: '请选择处理日期', trigger: 'change'}
        ]
      },
      data: {
        id: null,
        dealDate: null,
        dealRemark: null
      }
    };
  },
  created() {
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible (val) {
      if (!val) {
        this.data.id = null;
        this.data.dealDate = null,
        this.data.dealRemark = null
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (id, dealDate, dealRemark) {
      this.data.id = id;
      this.data.dealDate = dealDate
      this.data.dealRemark = dealRemark
      this.visible = true
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          confirmDeal(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("处理成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
